import { forwardRef } from "react";

import { cn } from "@/utils/css";

export const LoadboardValue = forwardRef(({ children, className = "" }, ref) => {
    return (
        <div ref={ref} className={cn("text-cm-p-text-primary text-base/[25px] font-semibold", className)}>
            {children}
        </div>
    );
});

LoadboardValue.displayName = "LoadboardValue";
